import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../assets/img/Icons/stage-checkmark-icon.svg'


const _hoisted_1 = { class: "new_client" }
const _hoisted_2 = { class: "identification_box" }
const _hoisted_3 = { class: "identification_list" }
const _hoisted_4 = { class: "checked" }
const _hoisted_5 = { href: "#" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = { class: "checked" }
const _hoisted_8 = { href: "#" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_10 = { class: "wait_aprove" }
const _hoisted_11 = { href: "#" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "cheked_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_13 = { class: "info_box mtop10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.profile.FirstName) + " " + _toDisplayString(_ctx.profile.SecondName), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("PersonalInformation")) + " ", 1),
            _hoisted_6
          ])
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Identification")) + " ", 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("a", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate("Liveness")) + " ", 1),
            _hoisted_12
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate(
            "WhenYourIdentityIdentifiedYouWillReceiveNotification"
          )) + " ", 1),
        _hoisted_14,
        _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate(
            "ToEmailAndSmsAfterThatYouWillImmediatelyGetAccessToAccount"
          )) + " ", 1),
        _hoisted_15,
        _createTextVNode(_toDisplayString(_ctx.$localization.getTranslate(
            "YourAccountMakeTransfersAndReplenishCard"
          )) + ". ", 1)
      ])
    ])
  ]))
}